import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthAdminGuard implements CanActivate, CanActivateChild {
    constructor(
        private auth: AuthService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> {
        return combineLatest([this.auth.isAuthenticated, this.auth.user$]).pipe(
            take(1),
            map(([isAuth, user]) => {
                if (!isAuth) return this.router.createUrlTree(['/login']);
                if (user && !user.isAnonymous) return true;    // admin
                if (user && user.isAnonymous) return this.router.createUrlTree(['/code']); // ABC
                return this.router.createUrlTree(['/login']);
            })
        );
    }

    canActivateChild(): Observable<boolean | UrlTree> {
        return this.canActivate();
    }
};
